export default __webpack_public_path__ + "img/laptop.b3a6c220.svg";